import {
  ChangeDetectionStrategy,
  Component,
  inject
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { LoaderDialogComponent } from './shared/provider/load-state-provider/components/loader-dialog/loader-dialog.component';
import { Toast } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { AppUpdaterService } from './core/update/service/app-updater.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, DialogModule, LoaderDialogComponent, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly appUpdater = inject(AppUpdaterService);
}
